export default {"src":"/_next/static/media/FILLED_INFO.2100bc6c.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};